import React from "react";
import styled from "styled-components";
import { Modal, ModalBody } from "reactstrap";
import Button from "../button";
import colors from "../../design/colors";
import fonts from "../../design/typography";

/* **********************************
 * TYPES
 ********************************** */
interface ConfirmButton {
  text: string;
  onClick: () => void;
  buttonColor: string;
  textColor?: string;
  width?: string;
  height?: string;
  fontStyle?: React.CSSProperties;
}

interface ConfirmModalProps {
  isOpen: boolean;
  message: React.ReactNode;
  buttons: ConfirmButton[];
  width?: string; // 모달 너비
  onClose: () => void; // 외부 클릭
}

/* **********************************
 * COMPONENT
 ********************************** */
const ConfirmModal = ({
  isOpen,
  message,
  buttons,
  onClose,
  width,
}: ConfirmModalProps) => {
  return (
    <StyledModal
      isOpen={isOpen}
      toggle={onClose}
      contentClassName="custom-modal-content"
      width={width}
      onClick={(e) => e.stopPropagation()}
    >
      <ModalBody
        onClick={(e) => e.stopPropagation()}
        style={{ padding: "24px", width: width }}
      >
        <div
          style={{
            ...fonts.body2Medium,
            color: colors.gray900,
            textAlign: "center",
            margin: "24px 0 32px 0",
          }}
        >
          {message}
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          {buttons.map((btn, index) => (
            <Button
              key={index}
              size="medium"
              width={btn.width ?? "112px"}
              height={btn.height ?? "40px"}
              text={btn.text}
              onClick={btn.onClick}
              buttonColor={btn.buttonColor}
              textColor={btn.textColor}
              style={btn.fontStyle}
            />
          ))}
        </div>
      </ModalBody>
    </StyledModal>
  );
};

export default ConfirmModal;

/* **********************************
 * Styles
 ********************************** */
const StyledModal = styled(Modal)<{ width?: string }>`
  z-index: 99999 !important;

  .modal-dialog {
    max-width: ${(props) => props.width ?? "max-content"};
    width: ${(props) => props.width ?? "350px"};
    z-index: 99999 !important;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .modal-content {
    z-index: 99999;
    max-width: ${(props) => props.width ?? "350px"};
    width: ${(props) => props.width ?? "350px"};
    position: relative;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
  }

  .modal-backdrop.show {
    z-index: 99998 !important;
  }
`;
